document.addEventListener('DOMContentLoaded',function() {

    const cover = document.getElementById('cover');
    
    const init = function() {
        document.documentElement.removeAttribute('style');
        document.documentElement.classList.add('is-loaded');
 
        
        document.getElementsByClassName('anim').length > 0 ? window.inviewInit() : false;        
        document.documentElement.classList.add('is-ready');
        
        setTimeout(function() {
            document.getElementsByClassName('js-privacyindex')[0] ? window.privacyWaypoints() : false;
            window.carousels();
            cover.remove();
            window.anims();
        }, 250);  
        
        // Detect url params
        const queryString = window.location.search;
        
        if (queryString) {
            const urlParams = new URLSearchParams(queryString),
                  target = urlParams.get('popup');

            if (target === '1') {
                window.popup();
            }
        }
    };
    
    window.addEventListener('load', init);

}, false);